export interface IAudioTimeCode {
  title: string,
  timeCodes: {
    id: string,
    start: number,
    end: number
  }[]
}

export interface IAudioTimeCodeService {
    getAudioTimeCode: (
      audioFile: string,
    ) =>  Promise<IAudioTimeCode | undefined>,
}

const AudioTimeCodeService: IAudioTimeCodeService = {

  getAudioTimeCode: (audioFile) => {
      const fetchUrl = audioFile.replace('.mp3', '.json'); 

      return fetch(
        fetchUrl,
        { 
          headers : { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
           }
        })
          .then((response) =>{
            return response.json();
          })
          .then(async(timeCodeJson) =>{
            return timeCodeJson;
          })
          .catch(error => {
            console.error(error);
            return undefined;
          });
    },
}

export default AudioTimeCodeService;